import { createFileRoute } from '@tanstack/react-router';

import { Decoupage } from '@/view/pages/Decoupages/Basic';

export const Route = createFileRoute('/_protected/$programId/decupagens/basica/$chapterNumber')({
  component: Decoupage,
});
